<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
  export default {
    name: 'App',
    data() {
      return {
        availWidth: 1920,
      }
    },
    methods: {
      setMeasureSize() {
        let _this = this
        _this.availWidth = window.screen.availWidth
        if (_this.availWidth <= 1440) {
          // 苹果mac
          document.documentElement.style.fontSize = '8.5px'
          return
        }
        if (_this.availWidth <= 1920) {
          // 普通显示屏
          document.documentElement.style.fontSize = '10px'
          return
        }
        if (_this.availWidth <= 2560) {
          // 2K显示屏
          document.documentElement.style.fontSize = '12px'
          return
        }
        if (_this.availWidth <= 3200) {
          // 3K显示屏
          document.documentElement.style.fontSize = '14px'
          return
        }
        if (_this.availWidth <= 3840) {
          // 4K显示屏
          document.documentElement.style.fontSize = '16px'
          return
        }
      },
    },
    created() {
      let _this = this
      _this.setMeasureSize()
    },
  }
</script>
<style lang="scss">
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /*color: #2c3e50;*/
  }
  body {
    padding: 0;
    margin: 0;
  }
  .custom-icon {
    margin-right: 10px;
    width: 5px;
    height: 24px;
    border-radius: 3px;
    background-color: #333;
  }
  .choose-options {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    .el-select {
      margin-bottom: 10px;
      min-width: 200px;
    }
    .el-input {
      position: relative;
      margin-left: 10px;
      width: 100%;
      max-width: 200px;
    }
    .el-input__suffix {
      height: 40px;
      display: flex;
      align-items: center;
      .el-icon-circle-close:before {
        font-size: 16px;
        color: rgba(152, 167, 185, 0.5);
        // color: red;
      }
    }
    .el-button,
    .el-date-editor {
      margin-left: 10px;
    }
  }

  .tips {
    font-size: 14px;
    color: #999;
  }
  .operation-icon {
    width: 36px;
    height: 36px;
    cursor: pointer;
  }
  .el-transfer-panel__list::-webkit-scrollbar {
    width: 0;
  }
</style>
